import { Injectable, signal } from '@angular/core';

/** Where the content area sits, as a fixed element would be placed over it. */
export interface ContentAreaBox {
  top: number;
  /** Distance from the right edge of the viewport. */
  right: number;
  width: number;
  height: number;
}

// Lets an overlay cover the page's content area (below its header, beside the sidebar) without
// knowing the layout. The dashboard layout observes its content area; the expanded request panel
// reads the box. It is measured again on every resize, so it follows the sidebar collapsing.
@Injectable({ providedIn: 'root' })
export class ContentAreaService {
  private readonly _box = signal<ContentAreaBox | null>(null);

  public readonly box = this._box.asReadonly();

  /** Starts measuring `el`; the returned function stops it and forgets the box. */
  public observe(el: HTMLElement): () => void {
    const measure = () => {
      const rect = el.getBoundingClientRect();
      this._box.set({
        top: rect.top,
        right: document.documentElement.clientWidth - rect.right,
        width: rect.width,
        height: rect.height,
      });
    };
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    measure();
    return () => {
      observer.disconnect();
      this._box.set(null);
    };
  }
}
